import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { Button } from './ui/Button';
export function Footer() {
  return <footer className="bg-[#263238] text-gray-300 pt-16 pb-8" data-id="element-46">
      <div className="container mx-auto px-4" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-48">
          {/* Brand Column */}
          <div data-id="element-49">
            <img src="https://cdn.magicpatterns.com/uploads/bitF4Fp2Mn5F2xN1PkGCY5/locanto_color.svg" alt="Locanto" className="h-8 mb-6 brightness-0 invert" data-id="element-50" />
            <p className="mb-6 text-gray-400 text-sm leading-relaxed" data-id="element-51">
              Your free local classifieds site. Find what you need, sell what
              you don't, and connect with your community in Singapore.
            </p>
            <div className="flex gap-4" data-id="element-52">
              <a href="#" className="hover:text-white transition-colors" data-id="element-53">
                <Facebook className="h-5 w-5" data-id="element-54" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-55">
                <Twitter className="h-5 w-5" data-id="element-56" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-57">
                <Instagram className="h-5 w-5" data-id="element-58" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-59">
                <Linkedin className="h-5 w-5" data-id="element-60" />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div data-id="element-61">
            <h4 className="text-white font-semibold mb-6" data-id="element-62">Categories</h4>
            <ul className="space-y-3 text-sm" data-id="element-63">
              <li data-id="element-64">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-65">
                  Jobs in Singapore
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-67">
                  Real Estate
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-69">
                  Buy & Sell
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-71">
                  Services
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-73">
                  Community
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-75">
                  Events
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-76">
            <h4 className="text-white font-semibold mb-6" data-id="element-77">Support</h4>
            <ul className="space-y-3 text-sm" data-id="element-78">
              <li data-id="element-79">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-80">
                  Help & FAQ
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-82">
                  Safety Tips
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-84">
                  Contact Us
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-86">
                  Terms of Use
                </a>
              </li>
              <li data-id="element-87">
                <a href="#" className="hover:text-[#00897B] transition-colors" data-id="element-88">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div data-id="element-89">
            <h4 className="text-white font-semibold mb-6" data-id="element-90">Start Posting</h4>
            <p className="text-sm text-gray-400 mb-6" data-id="element-91">
              Do you have something to sell? Post your ad on Locanto for free!
            </p>
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" data-id="element-92">
              <Button variant="orange" className="w-full font-bold" data-id="element-93">
                Post Free Ad
              </Button>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500" data-id="element-94">
          <p data-id="element-95">
            &copy; {new Date().getFullYear()} Locanto Singapore. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-96">
            <a href="#" className="hover:text-white" data-id="element-97">
              Mobile Site
            </a>
            <a href="#" className="hover:text-white" data-id="element-98">
              About Locanto
            </a>
            <a href="#" className="hover:text-white" data-id="element-99">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}